import UIIllustration from 'UIComponents/image/UIIllustration';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import styled from 'foundations-theming/utils';
import { useCallback } from 'react';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDescriptionDivWrapper = styled.div.withConfig({
  displayName: "SelectableButtonWithDescription__StyledDescriptionDivWrapper",
  componentId: "sc-1rved8w-0"
})(["font-size:12px;font-weight:400;color:", ";"], ({
  theme
}) => theme.color['do-not-use-slinky']);
export default function SelectableButtonWithDescription({
  buttonLabel,
  'data-test-id': dataTestId = 'selectable-button',
  description,
  disabled = false,
  illustrationName = '',
  isLocked = false,
  isSelected,
  onClick,
  upgradeKey = '',
  imageHeight = 80
}) {
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeKey);
  const handleClick = useCallback(() => {
    if (!isLocked) {
      onClick();
    } else {
      openUpgradeModal();
    }
  }, [isLocked, onClick, openUpgradeModal]);
  return /*#__PURE__*/_jsx(SelectableBox, {
    marginInlineStart: "0",
    marginBlockEnd: "200",
    padding: "400",
    maxInlineSize: "370px",
    "data-test-id": dataTestId,
    disabled: disabled,
    onClick: handleClick,
    selected: isSelected,
    type: "default",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(UIIllustration, {
        name: illustrationName,
        height: imageHeight,
        width: imageHeight
      }), /*#__PURE__*/_jsxs(Flex, {
        maxInlineSize: "230px",
        flexDirection: "column",
        marginInlineStart: "300",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          alignItems: "start",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginBlockEnd: "100",
            textAlign: "left",
            children: buttonLabel
          }), isLocked && /*#__PURE__*/_jsx(View, {
            maxBlockSize: "24px",
            children: /*#__PURE__*/_jsx(Text, {
              as: "small",
              color: "icon-core-subtle",
              textAlign: "left",
              children: /*#__PURE__*/_jsx(LockBadge, {
                "data-test-id": "locked-selectable-box",
                size: "600"
              })
            })
          })]
        }), /*#__PURE__*/_jsx(StyledDescriptionDivWrapper, {
          children: /*#__PURE__*/_jsx(Text, {
            textAlign: "left",
            children: description
          })
        })]
      })]
    })
  });
}